/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'photo-card';

/**
 * This is the component description.
 */
const Figure = ({
  id,
  className: userClassName,
  style,
  src,
  alt,
  caption
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: style
  // {...otherProps}
}, /*#__PURE__*/React.createElement("figure", null, /*#__PURE__*/React.createElement("img", {
  src: src,
  alt: alt
}), /*#__PURE__*/React.createElement("figcaption", null, caption || alt)));
Figure.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The source to the photo to be displayed
   */
  src: PropTypes.string,
  /**
   * The alternate text for the photo
   */
  alt: PropTypes.string,
  /**
   * The caption that will appear beneath the photo
   */
  caption: PropTypes.string
};
Figure.defaultProps = {
  // someProp:false
};
export default Figure;